import React from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { compareDate } from '../comparators/compareDate';
import { DateFilter } from '../filters/DateFilter';
import 'dayjs/locale/en-gb';

export const DateField: FieldComponent<
  string,
  string[],
  { loading?: boolean }
> = ({
  onChange,
  isActive,
  value,
  loading,
  intent,
  hasTooltip,
  disabled,
  mui,
  width,
  isMissing,
  compact,
}) => {
  return <></>;
};

DateField.includes = (query = [], value) =>
  query.length === 0 ||
  (value !== undefined &&
    query.some((date) => compareDate(new Date(date), new Date(value)) === 0));

DateField.comparator = (one = '', other = '') => {
  if (one === other) return 0;
  return one < other ? -1 : 1;
};

DateField.FilterRenderer = DateFilter;
